import type { FaireProductEntity } from "../../entity_types/product";

export const p_a89h9uud4t: FaireProductEntity = {
  token: "p_a89h9uud4t",
  type: "product",
  name: "Chocolate Caramels - Pure Sea Salt Caramel Candy",
  brandName: "Jacobsen Salt Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/c8cc064d6a4d20c0e23ac95682f6f53ef23f71789ec4fe38390b75301475fd6c.jpeg",
  priceDollars: 6.8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a681b29b8bc32f0d81177e3b13216ca8e40df59176eaaa05da6ab6680878f859.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
